module.exports = __webpack_public_path__ + "img/og-onvopay-banner.79bbbe2e.png";